import ReactRteSlate from './components';
export default ReactRteSlate;
